import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Log({ comment }: Props) {
  const { t } = useTranslation();
  const submissionDate = new Date(comment.createdDate);

  return (
    <div className={styles.log}>
      <p>{t(`log.${comment.content}`, { author: comment.author.name })}</p>
      <p>
        {submissionDate.toLocaleDateString()} {submissionDate.getHours()}h
        {submissionDate.getMinutes().toString().padStart(2, "0")}
      </p>
    </div>
  );
}

export { Log };
